<template>
  <div id="app">
    <!-- 导航栏 -->
    <div id="navigation_bar">
      <img id="logo" src="./assets/logo.png" alt="" />
      <div>
        <ul>
          <li>
            <a href="#">{{ status }}</a>
          </li>
          <li>
            <a href="#solution_content">{{ solutionContent }}</a>
          </li>
          <li>
            <a href="#superiority_content">{{ superiorityContent }}</a>
          </li>
          <li>
            <a href="#technical_architecture">{{ technicalArchitecture }}</a>
          </li>
          <li>
            <a href="#technical_advantages">{{ technicalAdvantages }}</a>
          </li>
          <li>
            <a href="#use_scenario">{{ useScenario }}</a>
          </li>

          <li>
            <a href="#model">{{ model }}</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 现状 -->
    <div class="title">{{ status }}</div>
    <div class="status">
      <div
        class="status_item"
        v-for="(item, index) in status_items"
        :key="index"
      >
        <img :src="item.img" class="status_img" alt="" />
        <span class="status_item_title">{{ item.title }}</span>
        <span class="status_item_content">{{ item.content }}</span>
      </div>
    </div>
    <!-- 解决方案-->
    <div class="title" id="solution_content">{{ solutionContent }}</div>
    <div class="solution_content">
      <div
        class="solution_item"
        v-for="(item, index) in solution_item_content"
        :key="index"
        :style="{ background: solution_item_bg_colorList[index % 2] }"
      >
        <span class="solution_line">|</span>
        <span class="solution_number">{{ index + 1 }}</span>
        <div class="solution_item_content">{{ item }}</div>
      </div>
    </div>

    <!-- 方案优势-->
    <div class="title" id="superiority_content">{{ superiorityContent }}</div>
    <div class="superiority_content">
      <div
        class="superiority_item"
        v-for="(item, index) in superiority_item_content"
        :key="index"
      >
        <span class="superiority_number">0{{ index + 1 }}</span>
        <div class="superiority_item_content" v-html="item"></div>
      </div>
    </div>
    <!-- 技术架构 -->
    <div class="technical_architecture" id="technical_architecture">
      <div class="technical_architecture_left">
        <img src="./assets/sdk.png" alt="" class="technical_architecture_img" />
      </div>
      <div class="technical_architecture_right">
        <span class="title" style="text-align: left; margin-top: 0px">{{
          technicalArchitecture
        }}</span>
        <div class="technical_architecture_content">
          <div
            class="technical_architecture_item"
            v-for="(item, index) in technical_architecture_content"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <!-- 技术优势 -->
    <div class="technical_advantages" id="technical_advantages">
      <div class="technical_advantages_left">
        <img
          src="./assets/web123.png"
          alt=""
          class="technical_advantages_img"
        />
      </div>

      <div class="technical_advantages_right">
        <span class="title" style="text-align: left">{{
          technicalAdvantages
        }}</span>
        <div class="technical_advantages_content">
          <div
            class="technical_advantages_item"
            v-for="(item, index) in technical_advantages_content"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="title" id="use_scenario">{{ useScenario }}</div>
    <div class="use_scenario_content">
      <div class="use_scenario_item" v-for="(item,index) in use_scenario_item" :key="index">
        <img :src="item.img" alt="" class="use_scenario_item_img" />
        <span class="use_scenario_item_title">{{
          item.title
        }}</span>
        <span class="use_scenario_item_content">{{
          item.content
        }}</span>
      </div>
    </div>
    <div class="title" id="model">{{model}}</div>
    <table border="1" class="model_revenue">
      <tr class="table_title">
        <th></th>
        <th>服务</th>
        <th>收费</th>
      </tr>
      <tr class="table_even_item" v-for="(item,index) in model_item" :key="index" :style="{ background: solution_item_bg_colorList[index % 2] }">
        <td>{{item.name}}</td>
        <td v-html="item.service"></td>
        <td v-html="item.fee">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      status: "现状",
      status_items: [
        {
          img: require("./assets/status1.png"),
          title: "垃圾邮件无法根治",
          content:
            "目前所有算法都是在影响造成之后的补救，无法预先识别不同系统之间的垃圾邮件识别规则不同，无法形成共识机制无法有效区分正常的广告邮件和垃圾邮件，影响正常邮件广告需求以及对该服务收费",
        },
        {
          img: require("./assets/status2.png"),
          title: "业务类型受协议限制，无法自由扩展",
          content:
            "对于邮件无法有效区分优先级，许多重要邮件被错过对于需要长期存储的邮件，服务器无法区分，会按照固定的逻辑删除当前没有有效的协议可以实现不同运营商之间的业务计费和业务协同",
        },
        {
          img: require("./assets/status3.png"),
          title: "跨国跨区域互信困难",
          content:
            "用户跨系统发送邮件时，不同的邮件服务商无法对同一封邮件采取相同处理方式跨国发送邮件时，不同国家之间的邮件服务器互信困对于大型的企事业单位，不同单位之间的邮件系统无法在公共网络中互相信任，只能在局域网中提供服务，对于居家办公或者公司高管十分不友好对于新型的邮件服务商或者较小的邮件服务商，大型的邮件服务企业会严格限制邮件交换的频率和附件的大小，甚至直接拒绝提供转发服务。",
        },
        {
          img: require("./assets/status4.png"),
          title: "安全问题无法根治",
          content:
            "当前大部分邮件服务免费，病毒传播的成本很低免费邮件系统造成诈骗邮件的成本很低大部分邮件服务商会明文存储用户邮件，并存在分析用户邮件数据的问题。",
        },
      ],
      solutionContent: "解决方案",
      solution_item_content: [
        "内部用户可以根据自身情况选购不同的邮票",
        "邮件服务提供商根据自身服务特色，发行自定义的区块链邮票",
        "友商可以通过购买邮票与该服务商建立互信",
        "广告商可以通过购买该邮票与该服务商建立合作",
        "大客户可以购买该服务商的邮票，使自建的邮箱服务器与该服务商实现智能的安全服务对接",
      ],
      solution_item_bg_colorList: ["#EFF2F6", "#F9FAFC"],
      superiorityContent: "方案优势",
      superiority_item_content: [
        "用户可以使用邮票表明邮票的重要性<br/>用户可以使用邮票制定邮件的存储时长，如果需要长期存储则提供更多邮票",
        "使用邮票的邮件被认定为非垃圾邮件，不需要内容识别和检测<br/>其它邮票服务提供商可以通过支付邮票为自己的用户提供丰富服务",
        "使用邮票的中小型邮件服务商或者大客户自建服务器默认是安全可信的<br/>使用邮票的邮件会被自动分配到邮票指定的文件夹，方便管理和使用",
        "天然支持Web3.0的邮件通讯协议<br/>任何企业均可以发行自身需要的邮票到区块链，友商使用时没有沟通和协商成本。<br/>区块链邮票天然使用NFT，是有使用场景和价值的NFT。",
      ],
      technicalArchitecture: "技术架构",
      technical_architecture_content: [
        "邮件服务商通过运营平台发布到区块链，并通过该平台宣传以及介绍该邮票的类型以及使用方式",
        "区块链邮票部署在区块链公链上，公开可查无法篡改",
        "用户通过发布平台采购区块链邮票",
        "客户端集成邮票SDK，在用户发送邮件时选择对应的邮票，SDK对邮件进行数字签名，并支付邮票",
        "服务器端集成邮票SDK，对邮票的有效性进行校验，并告知邮件服务器该如何处理该邮件",
        "邮件服务器根据邮票系统提供的信息，对不同邮件提供不同的服务。",
      ],
      technicalAdvantages: "技术优势",
      technical_advantages_content: [
        "用户无需改变使用习惯，解决了当前Web3.0系统使用门槛过高的问题。",
        "兼容现有的STMP，IMAP与POP协议通讯协议，同时对接了区块链公链网络架构。",
        "运营商改造成本低，接入流程简洁",
        "兼容Web2.0与Web3.0",
        "可以支持现有Web3.0架构下的邮箱服务系统。",
        "可以在较低成本下扩展到基于邮箱服务的区块链公链，所有使用该技术架构的邮箱服务商自动成为公链的网络节点。",
      ],
      useScenario: "使用场景",
      use_scenario_item:[
        {
          img:require("./assets/use1.png"),
          title:"场景1",
          content:"对于高管之间的邮件往来，需要使用特定邮票，以使得邮箱服务器进行分类处理，而不是所有人的所有邮件使用同样的处理逻辑，存储在同样的位置。"
        },
        {
          img:require("./assets/use2.png"),
          title:"场景2",
          content:"对于跨国业务往来，邮件数据会跨越不同国家的网络以及不同的邮件服务系统。邮件服务双方需要各自发行区块链邮票，为自己的用户提供安全可信的邮票服务，防止商务诈骗，提高邮件送达率。"
        }
      ],
      model:"营收模式",
      model_item:[
        {
          name:"pass服务",
          service:"邮票发布<br />邮票计费功能<br />服务器SDK<br />客户端SDK",
          fee:"按照API调用次数收费<br />每100次API调用<span style='color: red' >0.01</span>元<br />每邮票区块链部署<span style='color: red'>500元</span>"
        },
        {
          name:"软件集成",
          service:"服务器硬件由客户提供<br />软件功能包括邮票创建与管理<br />邮件客户端与服务器邮票钱包SDK<br />用户为集成邮箱服务的软件公司<br />用户的客户不面向互联网提供服务",
          fee:"软件初装费<span style='color: red'>30</span >万<br />软件维护费每年<span style='color: red'>3</span>万"
        },
        {
          name:"专利与方案授权",
          service:"提供SDK源代码参考<br />指导开发与方案设计",
          fee:"面向互联网邮箱服务商<br />根据服务商收费用户数，每用户每年收取<span style='color: red'>1</span>元专利费"
        },
        {
          name:"项目定制",
          service:"根据用户需求，开发集成邮票系统的邮箱客户端与服务器<br />根据用户需求，提供区块链邮票发行与管理<br />提供邮票及区块链系统开发与维护系统<br />系统维护",
          fee:"按照人月收费<br />提供驻场开发与服务对接"
        },
        {
          name:"代理软件",
          service:"使用公司发行的特定邮票<br />自行配置代理软件与邮箱客户端<br />自行配置邮票对应的邮件客户端文件夹<br />不允许服务器根据本公司专利方式，对代理软件的扩展字段解析，并进行业务分类等增值服",
          fee:"<span style='color: red'>免费</span>"
        }
      ]
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  background-color: rgb(237, 239, 242);
}
#logo {
  margin-left: 227px;
}
#navigation_bar {
  width: 100vw;
  height: 88px;
  display: flex;
  background-color: white;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
#navigation_bar ul {
  display: flex;
  flex-direction: row;
  margin-right: 160px;
  cursor: pointer;
}
#navigation_bar li {
  margin-left: 32px;
  font-size: 14px;
  font-weight: bolder;
}
/* 现状 */

.title {
  font-size: 53px;
  margin-top: 60px;
  font-weight: bolder;
}
.status {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
.status_item_title {
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  margin-top: 8px;
}
.status_item_content {
  font-size: 14px;
  text-align: left;
  margin-top: 9px;
  width: 30vw;
}
.status_item {
  display: flex;
  width: 35vw;
  flex-direction: column;
  justify-content: left;
}
.status_img {
  width: 193px;
  height: 137px;
  margin-top: 54px;
}
/* 解决方案 */
.solution_content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 160px;
  margin-right: 160px;
}
.solution_item {
  display: flex;
  margin-top: 36px;
  flex: 1;
  flex-direction: row;
  background: #f9fafc;
  padding-bottom: 10px;
}
.solution_line {
  width: 4px;
  height: 42px;
  display: flex;
  background: #da3930;
}

.solution_number {
  width: 20px;
  height: 44px;
  font-size: 32px;
  margin-left: 22px;
  font-family: AlibabaPuHuiTi-Heavy, AlibabaPuHuiTi;
  font-weight: 800;
  color: #da3930;
  opacity: 50;
  line-height: 44px;
}
.solution_item_content {
  font-size: 16px;
  margin-top: 44px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  margin-right: 22px;
  margin-left: -20px;
  text-align: left;
  color: #000000;
  line-height: 22px;
}

.solution_item_bg_odd {
  background: #eff2f6;
}

/* 方案优势 */
.superiority_content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  text-align: left;
  line-height: 20px;
}
.superiority_item {
  display: flex;
  flex-direction: row;
  margin-left: 36px;
  width: 40vw;
  background: white;
  align-items: center;
  margin-top: 18px;
  padding: 13px;
}
.superiority_number {
  width: 42px;
  height: 42px;
  font-size: 26px;
  font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
  font-weight: bold;
  text-align: center;
  line-height: 42px;
  color: #da3930;
  background: #da393033;
}
.superiority_item_content {
  margin-left: 12px;
  margin-right: 12px;
}
/* 技术架构 */
.technical_architecture {
  display: flex;
  flex-direction: row;
  padding-top: 82px;
  padding-bottom: 82px;
  background: #f9fafc;
  justify-content: center;
  margin-top: 83px;
}
.technical_architecture_left {
  flex: 1;
  margin-left: 185px;
  margin-right: 91px;
}
.technical_architecture_img {
  margin: 0 auto;
  width: 330px;
  height: 296px;
}
.technical_architecture_content {
  margin-top: 22px;
}
.technical_architecture_item {
  margin-top: 8px;
  font-size: 16px;
}
.technical_architecture_right {
  flex: 2;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-right: 42px;
}
/* 技术优势 */
.technical_advantages {
  display: flex;
  flex-direction: row;
  padding-top: 82px;
  background: #f9fafc;
  justify-content: center;
}
.technical_advantages_left {
  flex: 1;
  background: #03001f;
  height: 419px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.technical_advantages_img {
  margin: auto;
  width: 507px;
  height: 218px;
  text-align: center;
}
.technical_advantages_content {
  margin-top: 22px;
}
.technical_advantages_item {
  margin-top: 8px;
  color: white;
  font-size: 16px;
}
.technical_advantages_right {
  flex: 2;
  display: flex;
  padding-left: 42px;
  padding-right: 42px;
  background: #da3930;
  flex-direction: column;
  text-align: left;
}

/* <div class="use_scenario_content">
      <div class="use_scenario_item">
      <img src="" alt="" class="use_scenario_item_img">
      <span class="use_scenario_item_title"></span>
      <span class="use_scenario_item_content"></span> */
/* 使用场景 */
.use_scenario_content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 46px;
  padding-bottom: 18px;
}
.use_scenario_item {
  display: flex;
  width: 526px;
  background: white;
  margin-left: 68px;
  flex-direction: column;
}
.use_scenario_item_img {
  width: 464px;
  margin: 18px auto;
  height: 309px;
}
.use_scenario_item_title {
  background: #da393033;
  width: 66px;
  text-align: center;
  color: #da3930;
  margin-left: 31px;
  line-height: 32px;
  height: 32px;
  font-size: 18px;
}
.use_scenario_item_content {
  margin-left: 31px;
  margin-right: 31px;
  margin-top: 7px;
  text-align: left;
  font-size: 16px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: #000000;
  line-height: 22px;
  margin-bottom: 18px;
}

/* 模式营收 */
.model_revenue {
 
  padding-left: 160px;
  padding-right: 160px;
  margin: 0 auto;
  margin-top: 42px;
  border: 1px solid #e0e1e3;
}
.table_title {
  background: #da3930;
  height: 66px;
  color: white;
  font-size: 18px;
  font-weight: 500;
}
.model_revenue th {
  padding-left: 25px;
  padding-top: 12px;
}
.model_revenue td {
  padding-left: 25px;
  text-align: left;
  padding-top: 12px;
  font-size: 14px;
  padding-right: 25px;
  line-height: 20px;
}

.table_odd_item {
  background: white;
  padding-bottom: 18px;
  height: 160px;
}
.table_even_item {
  height: 160px;
  background: #f9fafc;
}
</style>
